/** Hub → consumer webhook `data` shapes (envelope built in worker). */
export function trimWebhookSnippet(text, max = 200) {
    if (!text?.trim())
        return undefined;
    const t = text.trim().replace(/\s+/g, ' ');
    return t.length > max ? `${t.slice(0, max - 1)}…` : t;
}
export function wordPressHubWebhookUrl(siteUrl) {
    const base = siteUrl.trim().replace(/\/$/, '');
    return `${base}/wp-json/ploko/v1/hub-event`;
}
export function leadCreatedWebhookPayload(params) {
    const data = { lead_id: params.lead_id };
    if (params.email)
        data.email = params.email;
    if (params.source_code)
        data.source_code = params.source_code;
    if (params.contact_name)
        data.contact_name = params.contact_name;
    if (params.company)
        data.company = params.company;
    if (params.wp_form_id)
        data.wp_form_id = params.wp_form_id;
    if (params.wp_post_id != null && params.wp_post_id !== '')
        data.wp_post_id = params.wp_post_id;
    return data;
}
export function automationExecutedWebhookPayload(params) {
    const data = {
        automation_id: params.automation_id,
        automation_name: params.automation_name,
        run_id: params.run_id,
        trigger_type: params.trigger_type,
    };
    if (params.trigger_event_type)
        data.trigger_event_type = params.trigger_event_type;
    if (params.context && Object.keys(params.context).length)
        data.context = params.context;
    if (params.trigger_payload && Object.keys(params.trigger_payload).length) {
        data.trigger_payload = params.trigger_payload;
    }
    return data;
}
export function replyReceivedWebhookPayload(params) {
    const data = { lead_id: params.lead_id };
    if (params.subject != null)
        data.subject = params.subject;
    if (params.match_method)
        data.match_method = params.match_method;
    if (params.from_email)
        data.from_email = params.from_email;
    if (params.message_id)
        data.message_id = params.message_id;
    if (params.campaign_id)
        data.campaign_id = params.campaign_id;
    const snip = trimWebhookSnippet(params.snippet ?? undefined);
    if (snip)
        data.snippet = snip;
    if (params.reprocessed)
        data.reprocessed = true;
    return data;
}
//# sourceMappingURL=eventPayloads.js.map